import { useLocation, useParams } from 'react-router';
import { IMPERSONATED_KEY } from '../constants/sessionStorage';

interface RouteParams extends Record<string, string | undefined> {
    userId: string;
}

const Impersonate = () => {
    const { search } = useLocation();
    const { userId } = useParams<RouteParams>();
    
    if (!userId) {
        throw new Error('User ID is required for impersonation');
    }
    
    sessionStorage.setItem(IMPERSONATED_KEY, userId);

    const urlParams = new URLSearchParams(search);
    const next = urlParams.get('next') ?? '/';

    window.location.href = next;
    return null;
};

export default Impersonate;
